import { memo } from 'react';
import { slugify } from '@bridebook/toolbox/src';
import { Box } from '@bridebook/ui';
import SectionText from '@bridebook/web/app-shared/components/supplier/sections/section-text/section-text';
import componentStyles from './award-category.style';
import { AwardData } from '@bridebook/web/app-shared/lib/supplier/types';

interface IProps {
  awards: AwardData[];
}

const AwardCategory = ({ awards }: IProps) => {
  const styles = componentStyles();

  return (
    <>
      {awards.map((award) => (
        <Box style={styles.awardWrap} key={`award-${slugify(award[0] || award[1])}`}>
          <Box
            as={award[1] ? 'a' : 'div'}
            style={styles.textWrap}
            href={getUrl(award)}
            target={getUrl(award) ? '_blank' : undefined}>
            <SectionText lineHeight={20}>{award[0] || award[1]}</SectionText>
          </Box>
        </Box>
      ))}
    </>
  );
};

const getUrl = ([, url]: AwardData) => (/https?:\/\//g.test(url || '') ? url : `https://${url}`);

export default memo(AwardCategory);
